import { render } from "./BaseShapeElement.vue?vue&type=template&id=2bad8b7f&scoped=true&ts=true"
import script from "./BaseShapeElement.vue?vue&type=script&lang=ts"
export * from "./BaseShapeElement.vue?vue&type=script&lang=ts"

import "./BaseShapeElement.vue?vue&type=style&index=0&id=2bad8b7f&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bad8b7f"]])

export default __exports__